// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1dJPT","title":"FrontImage_title__2P6xa"};